import PropTypes from "prop-types"
import { merge, get } from "lodash"
import classNames from "classnames"
import OPTooltip from "components/material/tooltip"
import { Description, Classification, CountryCurrency, ExtraInfo, NotHeld } from "./components"
import "./styles.scss"
import { TOOLTIP_ENTER_DELAY_MS } from "helpers/constants"

// classes is the class object for MUI components https://v4.mui.com/api/tooltip/#css
export default function PositionTooltip({ position, isActive, noWrapper, classes, children }) {
  if (!position) return children

  return <OPTooltip
    enterDelay={TOOLTIP_ENTER_DELAY_MS}
    // We don't want to override the original popper class because it's used to apply the base styles
    classes={merge({}, classes, { popper: classNames("position-tooltip-popper", get(classes, "popper")) })}
    title={<div className="position-tooltip-content">
      <Description {...position} />
      <Classification {...position} />
      <CountryCurrency {...position} />
      <NotHeld {...position} />
      <ExtraInfo {...position} isActive={isActive} />
    </div>}
    placement="bottom-start"
  >
    {noWrapper ? children : <span>{children}</span>}
  </OPTooltip>
}

PositionTooltip.propTypes = {
  position: PropTypes.shape({
    id: PropTypes.string.isRequired,
    currency: PropTypes.string,
    country: PropTypes.string,
    isUnmodeled: PropTypes.bool,
    basePercentEquity: PropTypes.number,
    positionPercentEquity: PropTypes.number,
    classification: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }),
  isActive: PropTypes.bool,
  classes: PropTypes.object,
  noWrapper: PropTypes.bool,
}
